import React, { useEffect, useState } from "react";
import { Global } from "../helpers/Global";

const construirArbol = (usuarios, gerenteId = null) => {
  return usuarios
    .filter(user => user.gerente_id === gerenteId)
    .map(user => ({
      ...user,
      children: construirArbol(usuarios, user.id)
    }));
};

// 🔹 Helpers de avatar (mismo criterio que en Gestión de Usuarios)
const getAvatarUrl = (usuario) => {
  if (!usuario?.avatar_url) return null;
  // avatar_url viene como "uploads/avatars/xxx.jpg"
  return `${Global.url}${usuario.avatar_url}`;
};

const getIniciales = (usuario) => {
  const nombre = (usuario?.nombre || "").trim();
  const apellidos = (usuario?.apellidos || "").trim();
  const n1 = nombre ? nombre.split(" ")[0][0] : "";
  const a1 = apellidos ? apellidos.split(" ")[0][0] : "";
  const combo = (n1 + a1).toUpperCase();
  if (combo) return combo;
  if (nombre) return nombre[0].toUpperCase();
  return "?";
};

const Nodo = ({ nodo }) => (
  <li>
    <div className="nodo-org" title={nodo.email}>
      {/* Avatar */}
      <div className="nodo-org-avatar">
        <div className="avatar-lista">
          {getAvatarUrl(nodo) ? (
            <img
              src={getAvatarUrl(nodo)}
              alt={`${nodo.nombre} ${nodo.apellidos || ""}`}
            />
          ) : (
            <div className="avatar-fallback">
              {getIniciales(nodo)}
            </div>
          )}
        </div>
      </div>

      {/* Texto */}
      <div className="nodo-org-texto">
        <span className="nodo-org-nombre">
          {`${nodo.nombre} ${nodo.apellidos || ""}`.trim()}
        </span>{" "}
        <small className="nodo-org-rol">({nodo.rol})</small>
      </div>
    </div>

    {nodo.children && nodo.children.length > 0 && (
      <ul>
        {nodo.children.map(child => (
          <Nodo key={child.id} nodo={child} />
        ))}
      </ul>
    )}
  </li>
);


export const Organigrama = () => {
  const [usuarios, setUsuarios] = useState([]);
  const [mensaje, setMensaje] = useState("");

  useEffect(() => {
    const fetchOrganigrama = async () => {
      try {
        const res = await fetch(`${Global.url}usuarios/organigrama`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        });
        if (res.ok) {
          const data = await res.json();
          setUsuarios(data);
        } else {
          setMensaje("Error al cargar organigrama.");
        }
      } catch (err) {
        console.error("Error al obtener organigrama:", err);
        setMensaje("No se pudo conectar con el servidor.");
      }
    };

    fetchOrganigrama();
  }, []);

  const arbol = construirArbol(usuarios);

  return (
    <div className="org-chart">
      <h2 className="centrar-titulo">Organigrama de la Empresa</h2>
      {mensaje && <p className="rojo">{mensaje}</p>}
      <ul>
        {arbol.map(nodo => <Nodo key={nodo.id} nodo={nodo} />)}
      </ul>
    </div>
  );
};
